<template>
<article class="wikiViewerWrap" ref="wikiWrap">
  <WikiIndex v-if="wikiIndex" :indexList=titleIndex :scrollMode=true @itemSelect="checkTitlePosition" @mounted="data=>bookmarkInfo=data"></WikiIndex>
  <div ref="scrollWrap" class="contentsWrap" @scroll="moveScroll">
    <section class="wikiContents" data-depth="0">
      <Process v-if="isProcess.isProcess"
        :item="isProcess"
        @load-content="(status) => awaitContent('process', status)"
      ></Process>
    </section>
    <section class="wikiContents" data-depth="0">
      <Keyword v-if="isKeyword.isKeyword"
        :item="isKeyword"
        :readonly="true"
        @load-content="(status) => awaitContent('keyword', status)"
      ></Keyword>
    </section>
    <WikiContent v-for="data in nodeData" :editor="data" ></WikiContent>
  </div>
  <Loading :visible="loading"/>
</article>
</template>
<script>
import CommNew from "@processEditor/CommNew";
import Process from '@components/protocolEditor/wikiProcess.vue'
import Keyword from '@components/protocolEditor/wikiKeyword.vue'
import WikiIndex from '@components/protocolEditor/wikiIndex.vue'
import WikiContent from './wikiViewerContents.vue'
import Loading from '@common/loading.vue'
import { typeOfJson } from "@processEditor/CommNew";
import MakeNodesInfomation from './wikiApi.js'


const makeNodes = new MakeNodesInfomation();

export default {
  name: 'wikiContent',
  mixins: [CommNew],
  props: {
    Data: {type: Object, default: function(){return{}}},
    flip: Function,
    depth: {
			type: Number,
			default() { return 0 }
		},
    wikiIndex: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      protocolType: null,
      contentData : null,
      isProcess: false,
			isKeyword: false, 
      contentRefs: {},
      titleIndex: [],
      nodeData: [],
      titleRefs: [],
      contentRefs: [],
      bookmarkInfo: null,
      scrollTimer: null,
      scrollTopPoint: 0,
      loading: false,
      canvas: null,
      awaitContentStatus: {
        'process' : false,
        'keyword': false,
        'content': false
      }
    }
  },
  components: {Process, Keyword, WikiContent, WikiIndex, Loading},
  computed: {
    
  },
  watch:{
    async Data(info) {
      console.log('Watch data');
      await this.loadProtocol();
      this.titleRefs = this.$refs.wikiWrap.querySelectorAll('[data-depth="0"] .title');
      this.scrollTopPoint = this.titleRefs[0].getBoundingClientRect();
      this.awaitContent('content', true);
    }
  },
  async mounted() {
    // console.log(this.Data);
    if(this.Data.protocolId || this.$route.query.protocolId) {
      await this.loadProtocol();
      this.titleRefs = this.$refs.wikiWrap.querySelectorAll('[data-depth="0"] .title');
      this.scrollTopPoint = this.titleRefs[0].getBoundingClientRect();
      this.awaitContent('content', true);
    }else {
      this.awaitContent('content', false);
    }
  },
  methods: {
    bodyHeight(){
      const app = document.getElementById("app");
      app.classList.add("height-auto");
      document.body.classList.add("height-auto")
    },
    awaitContent(key, status) {
      this.awaitContentStatus[key] = status;
      if( this.protocolType == 'UNIT' && this.awaitContentStatus['content'] == true ) {
        this.$emit('load-content', {status: true, contentStatus: this.awaitContentStatus});
        return
      }
      // for(let [key, value] of Object.entries(this.awaitContentStatus)) {
      //   if(value === false) {
      //     status = false;
      //     break
      //   }
      //   status = value;
      // }
      if( status === true) {
        this.$emit('load-content', {status, contentStatus: this.awaitContentStatus});
      }
      return status
    },
    objectToURLParams(obj) {
      return Object.entries(obj)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    },    
    async loadProtocol() {
      this.loading = true;
      // let response = await this.$wApi.protocol.gets({ 
      //   processId: this.Data.processId, 
      //   protocolId: this.Data.protocolId, 
      //   taKey : this.Data.TAKey,
      //   isPublish : this.Data.isPublish ?? '',
      //   isMemo : false , 
      //   isConent : true , 
      //   isComment  : false , 
      // });
      let param = {
        processId: this.Data.processId || this.$route.query.processId, 
        protocolId: this.Data.protocolId || this.$route.query.protocolId, 
        isPublish : (this.Data.isPublish || this.$route.query.isPublish ) ?? '',
        isMemo : false , 
        isConent : true , 
        isComment  : false , 
        taKey : this.Data.TAKey || this.$route.query.TAKey,
      };
      let response;
      if( !param.taKey ){
        response = await this.$wApi.protocol.gets(param);
      }else{
        param.taKey = param.taKey.replaceAll(' ', '+');
        // param.taKey = param.taKey.replaceAll('+', '%2B');        
        response = await this.$wApi.protocol.takey(param);
      }
      let issue;
      this.protocolType = response[0].protocolType;
      makeNodes.setNodeContents = typeOfJson(response[0].nodeContent);
      this.nodeData = [];
      if(this.Data.json) {
        // object deep copy를 위해 문자열로 변환 후 재수정
        issue = JSON.parse( typeof this.Data.json.issues == 'string' ? this.Data.json.issues : JSON.stringify(this.Data.json.issues));
        issue.map((item)=>{
          if( item.category === 'SHORTVALUE' ) item.display = false;
        });
      } else {
        issue = typeOfJson(response[0].json).issues;
      }
      let nodeDatas = makeNodes.makeNodeList( JSON.parse(JSON.stringify(issue)));

      this.titleIndex = [];

      nodeDatas[0].child.map( (item)=>{
        if(item.hasOwnProperty('isProcess')) {
          this.isProcess = item
          this.isProcess.processId = this.Data.processId;
          this.titleIndex.push(item);
        }
        if(item.hasOwnProperty('isKeyword')) {
          this.isKeyword = item
          this.titleIndex.push(item);
        }
      } )

      this.nodeData = await makeNodes.makeListData(nodeDatas[0].child);
      
      for(let item of this.nodeData) {
        if(item.step <= 0) {
          this.titleIndex.push(item);
        }
      }
      if( this.Data.TAKey ){
        this.bodyHeight();
      }
      this.loading = false;
    },
    
    checkTitlePosition(info) {
			if(!info || !this.titleRefs.length === 0) return
			let clientRect = this.titleRefs[info.index].getBoundingClientRect();
      this.$refs.scrollWrap.scrollTop = this.$refs.scrollWrap.scrollTop + clientRect.top - 120;
		},
    moveScroll(e){
      if(!this.wikiIndex || this.wikiIndex.lenght == 0)  return;
      clearTimeout(this.scrollTimer);
      let before=null;
      const checkPosition = (refPos) => {
        let index=0, height=0;
        for(let item of this.titleRefs) {
          let rect = item.getBoundingClientRect();
          if(before) {
            refPos = refPos - height;
            height = rect.top - before.rect.top;
            if( height - (height/3) > refPos) {
              this.bookmarkInfo.handler.select(index-1);
              break;
            }
          }
          before = {item, rect};
          index++;
        }
      }
      this.scrollTimer = setTimeout(()=>{
        checkPosition(this.$refs.scrollWrap.scrollTop)
      }, 100);
    }
  },
}

</script>
<style lang="scss" scoped>
// @import '@components/protocolEditor/wiki.scss';
// @import '@components/protocolEditor/wikiContent.scss';

.wikiViewerWrap {
  display: flex;
  min-width: 1200px; height: 100%;
  .contentsWrap {
    display: flex; flex-direction: column; gap: 20px 0;
    width: 100%;
    padding: 40px;
    overflow: auto;
    @include scrlbar;

  }

  .keywords {
    background-color: red;
  }
  .contentStep1 .title {
    padding: 12px;
    font-size: 20px;
    font-weight: 600;
  }
}
</style>
<style lang="scss">
.wikiViewerWrap {
  .wikiContents {
    .title {
      position: relative; top:0; left:0;
      padding: 12px;
      font-size: 20px;
      font-weight: 600
    }

    ol,ul{
      padding-left:18px;
      li{
        list-style: initial;
      }  
    }
		li{
			list-style: initial;
		}    
  }
  .keywords {
    table td { vertical-align: middle; }
  }
}
</style>